import News from 'actions/news';

export default News.createReducer();